import React from "react";
import Layout from "../components/organisms/Layout";
import { StaticImage } from "gatsby-plugin-image";
import emailBg from "../assets/images/email-bg.png";

const Recover = () => {
  return (
    <Layout>
      <section
        className="user-account login-form email-verify"
        style={{ backgroundImage: `url(${emailBg})` }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6">
              <h1 className="pb-2">Recupera tu contraseña</h1>
              <div className="card">
                <div className="card-body">
                  <h6 className="text-center mb-4">
                    Ingresa el correo electrónico que utilizaste para tu
                    registro.
                  </h6>
                  <form action="/recover-password-2">
                    <div className="row justify-content-center">
                      <div className="col-lg-8">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Correo electrónico"
                          />
                          <i className="icon-mail"></i>
                        </div>
                        <p className="px-5 mt-5">
                          <button
                            type="submit"
                            className="btn btn-warning btn-block"
                          >
                            Recuperar contraseña
                          </button>
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <StaticImage
                className="img-fluid px-5 mt-5"
                src="../assets/images/email-verify.png"
                alt="email"
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Recover;
